import { mergeDeep, crossBrowserFocus } from '../util';
import FC_Accessibility_Base from './base';

class FC_Accessibility_LegendEnabled extends FC_Accessibility_Base {
    constructor(svgRoot, chartInstance, alternateTexts, config) {
        super(svgRoot,chartInstance,alternateTexts,config);
    }

    /**
     * True if all plots are hidden by legend interaction as a result legends are also in disabled state
     * False otherwise
     */
    isAllLegendItemHidden() {
        let legendItems = this.chartInstance.apiInstance._components.legend[0]._components.legendItem;
        if(!legendItems) return false;
        for(let i=0; i<legendItems.length; i++) {
            if(legendItems[i]._legendState.indexOf("hidden") == -1) {
                return false;
            }
        }
        return true;
    }

    /**
     * Checks if all a specific legend items is diabled by legend interaction
     * @param {number} index
     */
    isLegendItemHidden(index) {
        let legendItems = this.chartInstance.apiInstance._components.legend[0]._components.legendItem;
        if(!legendItems) return false;
        return legendItems[index]._legendState.indexOf("hidden") >= 0;
    }

    /**
     * Make chart legend accessible
     */
    makeLegendAccessible() {
        if(this.chartInstance.getChartAttribute('showlegend') != "0") {
            // let legendRegion = this.svgRoot.querySelectorAll("g[class^=raphael][class$=legendGroup] > [class$=item]");
            // if(legendRegion && legendRegion.length > 0) {
            //     this.addTabIndexAndSetAria(legendRegion[0], null, null, "-1", "region");
            // }
            let legendTexts = this.svgRoot.querySelectorAll("g[class^=raphael][class$=legendGroup] > [class$=item] > text");
            if(legendTexts && legendTexts.length > 0) {
                let legendLength = legendTexts.length;
                let legendIndex = -1;
                function legendSelectOnKeyPress(event) {
                    event.stopPropagation();
                    let keyCaptured = false;
                    switch(event.keyCode) {
                        case 37:
                            //left arrow
                        case 38:
                            //down arrow
                            if(legendIndex > 0) {
                                --legendIndex;
                            }
                            keyCaptured = true;
                            break;
                        case 39:
                            //right arrow
                        case 40:
                            //up arrow
                            if(legendIndex < legendLength - 1) {
                                ++legendIndex;
                            }
                            keyCaptured = true;
                            break;
                        case 13:
                            //Enter
                        case 32:
                            //spacebar
                            this.chartInstance.apiInstance._components.legend[0]._components.legendItem[legendIndex].fireEvent('fc-click');
                            keyCaptured = true;
                            break;
                    }
                    if(keyCaptured) {
                        crossBrowserFocus(legendTexts[legendIndex]);
                        event.preventDefault();
                    }

                }

                for(let i=0; i<legendTexts.length; i++) {
                    let legendStat = {};
                    legendStat['{legendText}'] = legendTexts[i].innerHTML;

                    this.addTabIndexAndSetAria(legendTexts[i], this.alternateTexts.legendItem, mergeDeep(this.chartPropertyMap, legendStat), i==0 ? "0" : "-1", "button");
                    legendTexts[i].addEventListener('keydown', legendSelectOnKeyPress.bind(this), false);
                }

                //If first legend is focused by pressing tab then legendIndex will be zero
                legendTexts[0].addEventListener('focus', function(){
                    legendIndex = 0;
                });
            }
        }
    }
}

export { FC_Accessibility_Base, FC_Accessibility_LegendEnabled };